import { Box, TextField } from '@mui/material';
import * as React from 'react';
import { Question } from '../../types/questionnaire.types';
import { CharacterCounter } from '../shared/CharacterCounter';

interface EssayQuestionProps {
  question: Question;
  response: string;
  onEssayChange: (questionId: string, text: string, question: Question) => void;
}

export const EssayQuestion: React.FC<EssayQuestionProps> = ({
  question,
  response,
  onEssayChange,
}) => {
  return (
    <Box>
      <TextField
        multiline
        rows={6}
        fullWidth
        placeholder="Digite sua resposta aqui..."
        value={response || ''}
        onChange={(e) => onEssayChange(question.id, e.target.value, question)}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            background: '#ffffff',
            fontFamily: 'Roboto-Regular !important',
            fontSize: '11pt !important',
            color: '#374151 !important',
            '& fieldset': {
              borderColor: '#e5e7eb',
              borderWidth: '1px',
            },
            '&:hover fieldset': {
              borderColor: '#667eea',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#667eea',
              borderWidth: '2px',
            },
          },
          '& .MuiOutlinedInput-input': {
            '&::placeholder': {
              color: '#9ca3af',
              opacity: 1,
            },
          },
        }}
      />
      <CharacterCounter
        currentLength={response?.length || 0}
        maxLength={question.maxLength}
      />
    </Box>
  );
};
